(function () {
    /**
    * @see http://wiki.apache.org/solr/SolJSON#JSON_specific_parameters
    * @class Manager
    * @augments AjaxSolr.Class
    */
    AjaxSolr.Manager = AjaxSolr.Class.extend(
    /** @lends AjaxSolr.Manager.prototype */
  {

  /**
  * @param {Object} [attributes]
  */
  constructor: function (attributes) {
      AjaxSolr.extend(this, {
          // The most recent response from Solr.
          response: {},
          // A collection of all registered widgets.
          widgets: {},
          // The parameter store for the manager and its widgets.
          store: {
              'facet': 'true',
              'fl': 'id,name,ac*,rg*,type,form,dname,curdate,statdes,extfilename', // Which fields to return. No need to return freetext* since they are included in the snippets.
              'facet.field': 'form',
              'facet.limit': '20',
              'facet.mincount': '1',
              'f.topics.facet.limit': '50',
              'json.nl': 'map',
              'wt': 'json',
              'sort': 'curdate+desc',
              'hl': 'true',  // Turn on highlighting
              'hl.fl': 'freetext1, freetext2',  // For which fields to create highlighted snippets
              'hl.snippets': '6',  // How many snippets to extract
			  'isPagerClick': false
          },

          // Whether <tt>init()</tt> has been called yet.
          initialized: false,
          fq: null
      }, attributes);
  },

  /**
  * <p>This method should be called after the widgets have been
  * added. It should initialize the widgets, and do any other
  * one-time initializations.</p>
  */
  init: function () {
      this.initialized = true;
      for (var widgetId in this.widgets) {
          this.widgets[widgetId].init();
      }
  },
  
  newRequest: function (txt) {
      this.store['q'] = txt; //encodeURIComponent(txt);
      delete this.store['fq'];
	  this.fq = null;
		
	// Clean custom filters on sending new search request
	$('.hasDatepicker').val("");
	$('.custom-range').addClass("hidden");
	 
	// Reset filters to its default value
	this.store['fromDate'] = 0;
	this.store['toDate'] = 0;
		
    this.doRequest(0);
  },
  /**
  * Stores the Solr parameters to be sent to Solr and sends a request to Solr.
  *
  * @param {Boolean} [start] The Solr start offset parameter.
  */
  doRequest: function (start,uniqueCod) {
	  var _this;
	  var windowID;
	  if(uniqueCod){
		managerArray.forEach(function(element, index, array) {
			if (element.id == uniqueCod) {
				_this = array[index].manager;
				windowID = array[index].windowID;
				return true;
			}
		})
	  }
	  if(!_this){
		  _this = this;
		  windowID = "-1";
	  }
      if (_this.initialized === false) {
          _this.init();
      }
      // Allow non-pagination widgets to reset the offset parameter.
      if (start != 'undefined' && start != null)
          _this.store['start'] = start;

      for (var widgetId in _this.widgets) {
          _this.widgets[widgetId].beforeRequest();
      }

      /*
      var params = [];
      for (var name in this.store) {
      params.push(name + '=' + this.store[name]);
      }
      */
      var filt = _this.fq == null ? "" : "form:" + _this.fq;
      
      if (_this.store['rows'] == 'undefined' || _this.store['rows'] == null || _this.store['rows'] == 0)
          _this.store['rows'] = 10;
      if (_this.store['start'] == 'undefined' || _this.store['start'] == null)
          _this.store['start'] = 0;
      if (_this.store['fromDate'] == 'undefined' || _this.store['fromDate'] == null)
          _this.store['fromDate'] = 0;
      if (_this.store['toDate'] == 'undefined' || _this.store['toDate'] == null)
          _this.store['toDate'] = 0;
      esearchFind(_this.store['q'], filt, _this.store['start'], _this.store['rows'], _this.store['fromDate'], _this.store['toDate'],windowID);  // Magic API call for opening dialog with search results
  },

  /**
  * Adds a widget to the manager.
  *
  * @param {AjaxSolr.AbstractWidget} widget
  */
  addWidget: function (widget) {
      widget.manager = this;
      this.widgets[widget.id] = widget;
  },

  /**
  * Escapes a value, to be used in, for example, an fq parameter. Surrounds
  * strings containing spaces or colons in double quotes.
  *
  * @public
  * @param {String|Number} value The value.
  * @returns {String} The escaped value.
  */
  escapeValue: function (value) {
      // If the field value has a space, colon, quotation mark or forward slash
      // in it, wrap it in quotes, unless it is a range query or it is already
      // wrapped in quotes.
      if (value.match(/[ :\/"]/) && !value.match(/[\[\{]\S+ TO \S+[\]\}]/) && !value.match(/^["\(].*["\)]$/)) {
          return '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
      }
      return value;
  },

  hasFilter: function () {
      return ('fq' in this.store);
  },

  /**
  * This method is executed after the Solr response data arrives. Allows each
  * widget to handle Solr's response separately.
  *
  * @param {Object} data The Solr response.
  */
  handleResponse: function (data,uniqueCod) {
      this.response = data;

      for (var widgetId in this.widgets) {
		  this.widgets[widgetId].target = "." + uniqueCod +" " + this.widgets[widgetId].name;
          this.widgets[widgetId].afterRequest(uniqueCod);
      }
  }
});
})();
